export default "__VITE_ASSET__24173b80__"